<template>
  <div style="height: 30vh;  margin: auto">
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        {{ spaceLabel }}：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                <span class="text-blue"
                      style="font-size: inherit;height: 28px;line-height: 28px;">{{ spaceValue }}</span>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        空间名称：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-input class="inline-input" placeholder="请输入空间名称" size="mini" style="width: 80%"
                  v-model="formData.cnName"></el-input>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        行政区域：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-cascader
          :options="options"
          :props="defaultProps"
          @change="regionChange"
          ref="demoCascader"
          size="mini"
          style="padding-bottom: 5px;width: 80%"
          v-model="formData.region"
        ></el-cascader>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        经纬度：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-input class="inline-input" placeholder="请输入经度" size="mini" style="width: 39.5%;margin-right: 1%"
                  v-model="formData.longitude"></el-input>
        <el-input class="inline-input" placeholder="请输入纬度" size="mini" style="width: 39.5%"
                  v-model="formData.latitude"></el-input>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        是否是逻辑空间：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          @change="select_status"
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 80%"
          v-model="formData.type">
          <el-option
            :value="1"
            label="是">
          </el-option>
          <el-option
            :value="0"
            label="否">
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        备注：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-input
          :rows="2"
          autosize
          class="inline-input"
          placeholder="请输入备注"
          style="width: 80%"
          type="textarea"
          v-model="formData.note">
        </el-input>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        空间内景图：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15"
              v-if="formData.bgImage">
        <div class="upload-div">
          <img :src="$ftpUrl + formData.bgImage"
               class="upload-img">
          <div class="delete-icon">
                        <span @touchstart="imageRemove" @click="imageRemove">
                            <i class="el-icon-delete"></i>
                        </span>
          </div>
        </div>
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15"
              v-else>
        <el-upload
          :action="uploadUrl"
          :auto-upload="true"
          :headers="token"
          :before-upload="beforeUpload"
          :accept="'image/*'"
          :on-error="imageChangeError"
          :on-success="imageChangeSuccess"
          :show-file-list="false"
          class="upload-demo"
          drag
          style="margin-bottom: 60px;"
          v-model="formData.bgImage">
          <i class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
        </el-upload>
      </el-col>
    </el-col>
    <el-col :span="24" class="hidden-sm-and-up" style="height: 8px;"></el-col>
    <el-col :span="24" class="hidden-md-and-down" style="height: 13px;"></el-col>
  </div>
</template>

<script>
import {serviceUrl} from "@/utils/request";
import lodash from "lodash";
import {imgUploadAstrict} from '@/constant/img-upload-astrict';

export default {
  name: "modify",
  props: ["spaceForm", "spaceLabel", "spaceValue", "options"],
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      token: {},
      allowSuffix:["bmp", "jpg", "png", "tif", "gif", "pcx", "tga", "exif", "fpx", "svg", "psd", "cdr", "pcd", "dxf", "ufo", "eps", "ai", "raw", "WMF", "webp"],
      // 选择的区域
      region: '',
      uploadUrl: window.g.gatewayUrl.slice(0, -1) + serviceUrl.deviceService + '/api/upload',
      defaultProps: {
        label: 'title',
        value: 'id',
        children: 'children'
      },
      formData: {},
    }
  },
  watch: {
    spaceForm: {
      handler() {
        this.initPosition()
      },
      deep: true,
    },
    formData() {
      this.$emit('receiveData', this.formData)
    },
  },
  mounted() {
    console.log(this.allowSuffix.toString());
    this.token = {Authorization: 'Bearer' + this.$cookies.get('token')};
    this.initPosition();
  },
  methods: {
    initPosition() {
      this.formData = lodash.cloneDeep(this.spaceForm)
    },
    select_status() {
      this.$forceUpdate();
    },
    // 文件类型校验
    beforeUpload(file) {
      return imgUploadAstrict(file, this);
    },
    imageChangeError() {
      this.$message.error("文件上传失败!")
    },
    imageChangeSuccess(file) {
      this.formData.bgImage = file.data.domain + file.data.url;
      // 重新渲染
      this.$forceUpdate();
    },
    imageRemove() {
      this.formData.bgImage = '';
      // 重新渲染
      this.$forceUpdate();
    },
    regionChange(res) {
      if (res) {
        let obj = this.$refs['demoCascader'].getCheckedNodes()[0];
        if (obj !== undefined) {
          // let pathLabels = obj.pathLabels;
          let data = lodash.cloneDeep(obj.data);
          // 经度
          this.formData.longitude = data.lng;
          // 维度
          this.formData.latitude = data.lat;
        } else {
          // 经度
          this.formData.longitude = '';
          // 维度
          this.formData.latitude = '';
          this.formData.region = '';
        }
      }
    },
  }
}
</script>

<style scoped>
.delete-icon {
  line-height: 80px;
  height: 80px;
  width: 80px;
  position: absolute;
  text-align: center;
  display: none;
}

.upload-img {
  position: absolute;
  width: 80px;
  height: 80px;
}

.upload-div {
  margin-bottom: 145px;
}

.upload-img:hover + .delete-icon {
  display: block;
}

.delete-icon:hover {
  display: block;
}
</style>
